import Link from 'next/link';
import React from 'react';

import RecaptchaTypography from './ReCaptchaTypography';

const ReCaptchaTAC: React.FC = ({ ...rest }) => {
  return (
    <RecaptchaTypography
      variant='small'
      color='coolGrey'
      weight='light'
      {...rest}
    >
      This site is protected by reCAPTCHA and the Google{' '}
      <Link
        href='https://policies.google.com/privacy'
        target='_blank'
      >
        Privacy Policy
      </Link>{' '}
      and{' '}
      <Link
        href='https://policies.google.com/terms'
        target='_blank'
      >
        Terms of Service
      </Link>
    </RecaptchaTypography>
  );
};

export default ReCaptchaTAC;
